module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAA8BAMAAAApudEQAAAAG1BMVEUAAABLl/9Ll/9Ll/9Ll//////u9f9/tf/s9P8od7i8AAAABHRSTlMA8a0mzjE4JAAAAJtJREFUSMft1d0JhDAQBOCFuwpOGziwAO1AZVpYOxA7sAXb9gchLgxsXvzFeUv4XrIhGQn5/BHyy4WlwDYJNZkxNTWpMRU1gFkcauxUSvmCZN5fJlXAMUgkc00tqWsqgWvwmmB6Ve0c006mcYzOeQ0zvW7TUdMa01CjNo8x5OzODIfT7/S2xn3L67CHC/1Re5qYTonpppiOi+nKEVWjzpEK/LX/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/yyhy_icon_ylqx.png
// module id = I1Eq
// module chunks = 0